module.exports = __webpack_public_path__ + "img/autoprod-2.f8cad575.jpg";